import common from '@/services/common'
import qs from "qs"

export default {
  getSchedule(date) {
    return common.executeExternal("get",
      `${process.env.VUE_APP_STATS_API_BASE_URL}/api/v1/schedule/?sportId=1&date=${date.format('L')}`,
    )
  },
  getSeasons(seasons) {
    const queryParams = {
      season: seasons ? seasons.join() : null,
    }
    return common.executeExternal("get",
      `${process.env.VUE_APP_STATS_API_BASE_URL}/api/v1/seasons/?sportId=1&${qs.stringify(queryParams, { encode: false, skipNulls: true })}`,
    )
  },
}